"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { StateView } from "@/components/common/StateView";
import { sanitizeEmail } from "@/lib/security/sanitize";
import { isDemoMode } from "@/lib/runtime/mode";
import { AdminThemeRoot } from "@/components/admin/AdminThemeRoot";
import { AdminSectionHeader } from "@/components/admin/ui/AdminSectionHeader";

export default function AdminLoginPage() {
  const router = useRouter();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");

    const safeEmail = sanitizeEmail(email);
    const safePassword = password.trim();

    if (!safeEmail || !safePassword) {
      setError("E-posta ve şifre alanları zorunludur.");
      return;
    }

    setLoading(true);

    const response = await fetch("/api/admin/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: safeEmail, password: safePassword }),
    });

    setLoading(false);

    if (!response.ok) {
      const body = await response.json().catch(() => ({ error: "Giriş başarısız." }));
      setError(body?.error ?? "Giriş başarısız.");
      return;
    }

    router.push("/admin/orders");
    router.refresh();
  };

  const showDemoInfo = isDemoMode();

  return (
    <AdminThemeRoot>
      <main style={{ maxWidth: "420px", margin: "4rem auto" }}>
        <form className="card grid" onSubmit={handleLogin}>
          <AdminSectionHeader title="Admin Girişi" />
          {showDemoInfo ? <StateView message="Demo giriş: demo@menuqrpay.local / demo1234" /> : null}
          <input value={email} onChange={(event) => setEmail(event.target.value)} type="email" required placeholder="admin@ornek.com" autoComplete="email" />
          <input value={password} onChange={(event) => setPassword(event.target.value)} type="password" required placeholder="******" autoComplete="current-password" />
          {error ? <StateView message={error} variant="error" /> : null}
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </main>
    </AdminThemeRoot>
  );
}
